import { render, staticRenderFns } from "./RecruitTags.vue?vue&type=template&id=2a497c72&scoped=true&"
import script from "./RecruitTags.vue?vue&type=script&lang=js&"
export * from "./RecruitTags.vue?vue&type=script&lang=js&"
import style0 from "./RecruitTags.vue?vue&type=style&index=0&id=2a497c72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a497c72",
  null
  
)

export default component.exports